import { Avatar, Checkbox, Flex, Text, Tooltip } from "@mantine/core";
import { IconPhoto } from "@tabler/icons";
import React from "react";
import { ProgramApi } from "../../apis";
import noimage from "../../assets/no-image.png";
import { ColumnType, Table } from "../table";

export function SmeFirstsStep({ filters, setSelectedSmes }: any) {
  const [selection, setSelection] = React.useState<any[]>([]);

  const columns = useHeader({
    onChangeChecked: (checked: boolean, record: any) => {
      let selecteds = selection;

      if (checked) {
        selecteds = [...selecteds, record];
      } else {
        selecteds = selecteds.filter((s) => s.id !== record.id);
      }

      setSelection(selecteds);
      setSelectedSmes(selecteds);
    },
  });

  return <Table name="sme.program.onboarding.list" columns={columns} filters={filters} loadData={(data) => ProgramApi.smeSelect(data!)} />;
}

const useHeader = ({ onChangeChecked }: any): ColumnType<any>[] => [
  {
    title: "#",
    render: (_r, index) => `${index + 1}`,
    width: "30px",
  },
  {
    title: "",
    render: (record, index) => (
      <Tooltip label={!record.isSelectable ? "Тухайн харилцагчийг сонгох боломжгүй" : "Харилцагч сонгох"}>
        <Checkbox name={`smes[${index}].checked`} onChange={(e) => onChangeChecked(e.target.checked, record)} disabled={!record.isSelectable} />
      </Tooltip>
    ),
    width: "30px",
  },
  {
    title: "ТТД",
    sorter: true,
    dataIndex: "regNumber",
    render: (record) => {
      return (
        <Text size="sm" weight={500} c="#44566C">
          {record?.regNumber}
        </Text>
      );
    },
  },
  {
    title: "Партнер нэр",
    sorter: true,
    dataIndex: "partnerName",
    render: (record) => {
      return (
        <Flex align="center" gap={8} w={200}>
          <Text w={220}>
            <Text size="sm" weight={500} c="#44566C">
              {record?.partnerName || "-"}
            </Text>
            <Text size="sm" weight={500} c="#3e166e">
              {record?.partnerRefCode || "-"}
            </Text>
          </Text>
        </Flex>
      );
    },
  },
  {
    title: "Нийлүүлэгч бизнес нэр",
    sorter: true,
    dataIndex: "partnerName",
    render: (record) => {
      return (
        <Flex align="center" gap={8} w={200}>
          <Text w={220}>
            <Text size="sm" weight={500} c="#44566C">
              {record?.profileName || "-"}
            </Text>
            <Text size="sm" weight={500} c="#3e166e">
              {record?.refCode || "-"}
            </Text>
          </Text>
        </Flex>
      );
    },
  },
  {
    title: "Нийлүүлэгчийн санхүү",
    sorter: true,
    dataIndex: "partnerName",
    render: (record) => {
      return (
        <Flex align="center" gap={8} w={200}>
          <Avatar src={record?.finUser?.avatar !== null ? record?.finUser?.avatar : noimage} size={42}>
            <IconPhoto />
          </Avatar>
          <Text w={220}>
            <Text size="sm" weight={500} c="#868E96">
              {record?.finUser?.lastName || "-"}
            </Text>
            <Text size="sm" weight={500} c="#44566C">
              {record?.finUser?.firstName || "-"}
            </Text>
          </Text>
        </Flex>
      );
    },
  },
  {
    title: "Нийлүүлэгч орлогын данс",
    dataIndex: "regNumber",
    render: (record) => {
      return (
        <Flex align="center" gap={8} w={200}>
          <Avatar src={record?.smeInAcc?.icon !== null ? record?.smeInAcc?.icon : noimage} size={42}>
            <IconPhoto />
          </Avatar>
          <Text w={220}>
            <Text size="sm" weight={500} c="#868E96">
              {record?.smeInAcc?.bankName || "-"}
            </Text>
            <Text size="sm" weight={500} c="#44566C">
              {record?.smeInAcc?.number || "-"}
            </Text>
          </Text>
        </Flex>
      );
    },
  },
  {
    title: "Нийлүүлэгч зарлагын данс",
    dataIndex: "regNumber",
    render: (record) => {
      return (
        <Flex align="center" gap={8} w={200}>
          <Avatar src={record?.smeOutAcc?.icon !== null ? record?.smeOutAcc?.icon : noimage} size={42}>
            <IconPhoto />
          </Avatar>
          <Text w={220}>
            <Text size="sm" weight={500} c="#868E96">
              {record?.smeOutAcc?.bankName || "-"}
            </Text>
            <Text size="sm" weight={500} c="#44566C">
              {record?.smeOutAcc?.number || "-"}
            </Text>
          </Text>
        </Flex>
      );
    },
  },
];
